import { htmlSafe } from '@ember/template';
import BvInline from 'volta/components/bv-inline';
import CodeDesc from 'volta/components/code-desc';

import type { TOC } from '@ember/component/template-only';
import type SearchEntry from 'volta/models/search-entry';
import type { CodeDescPayload } from 'volta/models/search-entry';

interface BvAppSearchEntryDefaultSignature {
  Args: {
    entry: SearchEntry<CodeDescPayload>;
  };
  Element: HTMLElement;
}

const BvAppSearchEntryDefaultComponent: TOC<BvAppSearchEntryDefaultSignature> = <template>
  <BvInline @gap='2' @wrap={{false}} class='u-overflow-hidden' ...attributes>
    <CodeDesc
      @code={{htmlSafe @entry.payload.code}}
      @desc={{if @entry.payload.description (htmlSafe @entry.payload.description)}}
      class='u-flex-1 u-ellipsis'
    />
  </BvInline>
</template>;

export default BvAppSearchEntryDefaultComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvAppSearch::Entry::Default': typeof BvAppSearchEntryDefaultComponent;
    'bv-app-search/entry/default': typeof BvAppSearchEntryDefaultComponent;
  }
}
